import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DatatableTables from "./DatatableTables";
import axios from "axios";

const Products = () => {
  const [itemList, setItemList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const req = await axios.get(
        `${process.env.REACT_APP_MYAPI_URL}/getProduct`
      );
      const res = await req.data;
      if (res) {
        // console.log('pp',res);
        setItemList(res?.products);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <DatatableTables
        itemList={itemList}
        loading={loading}
        fetchData={fetchData}
      />
    </React.Fragment>
  );
}
export default Products;
